module.exports = __webpack_public_path__ + "static/media/EXERGUECHAP1.8cff1dc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/EXERGUECHAP1.png
// module id = 250
// module chunks = 0